import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { obtenerProductoPorId } from './Api';
import html2canvas from "html2canvas";

export default function DetalleReceta() {

    const id = useParams().id;
    const [receta, setReceta] = useState([]);

    useEffect(() => {
        obtenerProductoPorId(id).then(receta => setReceta(receta));
    });

    const {
        strDrink: nombre,
        strDrinkThumb: imagen,
        strInstructions: instrucciones,
        strAlcoholic: alcoholica,
        strTags: tags,
        strCategory: categoria,
    } = receta;


    const ingredientes = Object.keys(receta)
        .filter((key) => key.includes("strIngredient"))
        .reduce((obj, key) => {
            return Object.assign(obj, {
                [key]: receta[key]
            });
        }, {});

    let ingredientesList = [];
    Object.values(ingredientes).forEach((ingrediente, i) => {
        if (ingrediente) {
            ingredientesList.push(<li key={i} className="list-group-item">{ingrediente}</li>);
        }
    });

    const medidas = Object.keys(receta)
        .filter((key) => key.includes("strMeasure"))
        .reduce((obj, key) => {
            return Object.assign(obj, {
                [key]: receta[key]
            });
        }, {});

    let medidasList = [];
    Object.values(medidas).forEach((medida, i) => {
        if (medida) {
            medidasList.push(<li key={i} className="list-group-item">{medida}</li>);
        }
    });


    const downloadReceta = (e) => {
        html2canvas(document.querySelector("#export"), { useCORS: true })
            .then(canvas => {
                let img = canvas.toDataURL("receta/jpg");
                let link = document.createElement("a");
                link.download = "receta.jpg";
                link.href = img;
                link.click();
            })
    }


    return (
        <>
            <section className='bg-dark'>
                <div className='container-fluid d-flex justify-content-center pt-4'>
                    <div id='export' className="detalle-receta card bg-dark text-light" style={{ width: `25rem` }} >
                        <img className="card-img-top" src={imagen} alt='imagen del producto' />
                        <div className="card-body">
                            <h3 className="card-title"><b>{nombre}</b></h3>
                            <h4 className="card-text">{alcoholica}</h4>
                            <div>
                                <span class="badge  rounded-pill text-bg-light my-2">{tags}</span>
                                <span class="badge  rounded-pill text-bg-light my-2">{categoria}</span>
                            </div>
                            <p className='card-text'>{instrucciones}</p>

                            <table class="table table-dark table-bordered .table-sm ">
                                <thead>
                                    <tr>
                                        <th scope="col">Ingredientes</th>
                                        <th scope="col">Medidas</th>
                                    </tr>
                                </thead>
                                <tbody class="table-group-divider">
                                    <tr>
                                        <td>
                                            <ul>{ingredientesList}</ul>
                                        </td>
                                        <td>
                                            <ul>{medidasList}</ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
                <button onClick={downloadReceta} className="btn btn-primary mx-auto d-flex my-2 producto-btn">Descargar receta</button>
            </section >
        </>
    )

}